/* eslint-disable unicorn/no-array-reduce */
/* eslint-disable no-undef */

export const parseCookies = () => {
  return window.document.cookie.split(";").reduce(function (acc, kvp) {
    const kv = kvp.split("=");
    const key = kv[0].trim();
    acc[key] = kv[1];
    return acc;
  }, {});
};

export const parseJwt = (token) => {
  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace("-", "+").replace("_", "/");
  return JSON.parse(window.atob(base64));
};

export const parseQuery = () => {
  const qs = window.location.search.slice(1);
  return qs.split("&").reduce((acc, kvp) => {
    const kv = kvp.split("=");
    if (kv[0]) {
      acc[kv[0]] = kv[1];
    }
    return acc;
  }, {});
};

export const uuid = () => {
  const url = URL.createObjectURL(new Blob());
  return url.slice(Math.max(0, url.lastIndexOf("/") + 1));
};

export const debounce = (callback, wait) => {
  let timeoutId;
  return (...args) => {
    window.clearTimeout(timeoutId);
    timeoutId = window.setTimeout(() => {
      callback(...args);
    }, wait);
  };
};

export const formatDate = (date = new Date()) => {
  date = date instanceof Date ? date : new Date(date);
  return date.toLocaleDateString("en-US", {
    month: "long",
    year: "numeric",
    day: "numeric",
  });
};

export const formatTtlMinutes = (ttl) => {
  const totalMinutes = Math.ceil(ttl);
  const minutesInDay = 24 * 60;
  const days = Math.floor(totalMinutes / minutesInDay);
  const remainderAfterDays = totalMinutes % minutesInDay;
  const hours = Math.floor(remainderAfterDays / 60);
  const minutes = remainderAfterDays % 60;

  const parts = [];
  if (days > 0) {
    parts.push(`${days} ${days === 1 ? "day" : "days"}`);
  }
  if (hours > 0) {
    parts.push(`${hours} ${hours === 1 ? "hour" : "hours"}`);
  }
  if (minutes > 0) {
    parts.push(`${minutes} ${minutes === 1 ? "minute" : "minutes"}`);
  }

  if (parts.length === 0) {
    return "0 minutes";
  }
  if (parts.length === 1) {
    return parts[0];
  }
  if (parts.length === 2) {
    return `${parts[0]} and ${parts[1]}`;
  }

  return `${parts[0]} ${parts[1]} and ${parts[2]}`;
};

export const capitalize = (str) => {
  if (!str || typeof str !== "string") return "";

  return str
    .split(" ")
    .map((word) =>
      word.length > 0 ? word.charAt(0).toUpperCase() + word.slice(1) : ""
    )
    .join(" ");
};

export const getErrorMessage = (data) => {
  let errorMessage;
  if (data === undefined) {
    errorMessage = "Something went wrong. Please try again.";
  } else {
    errorMessage =
      data.detail == undefined
        ? "Something went wrong. Please try again."
        : data.detail;
  }
  return errorMessage;
};

export const checkPromisesFulfilled = (promises, errorMessage) => {
  if (promises?.some((p) => p.status === "rejected")) {
    throw new Error(errorMessage ?? defaultErrorMessage);
  }
  return promises;
};

export const getPromisesValues = (promises) => {
  return promises.map((p) => p.value);
};

export const stringToInteger = (value) => {
  if (!value || value === "") {
    return undefined;
  }

  const num = Number(value);
  return isNaN(num) ? undefined : num;
};

export const isNullish = (value, validateString = false) => {
  if (validateString) {
    return ["undefined", "null", ""].includes(value);
  }

  return value === undefined || value === null;
};

export const parseStringBoolean = (value) =>
  String(value).trim().toLowerCase() === "true";

// === Functions for testing/developing purposes === //
export const noop = () => {};

export const sleep = async ({ ms, callback } = { ms: 1000, callback: noop }) =>
  new Promise((resolve) =>
    setTimeout(() => {
      callback?.();
      resolve();
    }, ms)
  );

export const copyToClipboard = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
  } catch (error) {
    console.error("Error:", error);
  }
};

/**
 * Gets device information.
 * @returns {Object} Device information object
 */
export const getDeviceInfo = () => {
  const userAgent = navigator.userAgent;
  const screen = window.screen;

  // Simple browser detection
  let browserName = "Unknown";
  let browserVersion = "Unknown";

  if (userAgent.includes("Chrome")) {
    browserName = "Chrome";
    const match = userAgent.match(/Chrome\/(\d+\.\d+)/);
    browserVersion = match ? match[1] : "Unknown";
  } else if (userAgent.includes("Firefox")) {
    browserName = "Firefox";
    const match = userAgent.match(/Firefox\/(\d+\.\d+)/);
    browserVersion = match ? match[1] : "Unknown";
  } else if (userAgent.includes("Safari")) {
    browserName = "Safari";
    const match = userAgent.match(/Version\/(\d+\.\d+)/);
    browserVersion = match ? match[1] : "Unknown";
  }

  // Simple OS detection
  let osName = "Unknown";
  let osVersion = "Unknown";

  if (userAgent.includes("Mac OS X")) {
    osName = "macOS";
    const match = userAgent.match(/Mac OS X (\d+[._]\d+)/);
    osVersion = match ? match[1].replace("_", ".") : "Unknown";
  } else if (userAgent.includes("Windows")) {
    osName = "Windows";
    const match = userAgent.match(/Windows NT (\d+\.\d+)/);
    osVersion = match ? match[1] : "Unknown";
  } else if (userAgent.includes("Linux")) {
    osName = "Linux";
  }

  return {
    device_type: "web",
    device_access_channel: "browser",
    device_os: {
      name: osName,
      version: osVersion,
    },
    device_model: navigator.platform || "Unknown",
    device_browser: {
      name: browserName,
      version: browserVersion,
    },
    device_screen: {
      width: screen.width,
      height: screen.height,
      pixel_density: window.devicePixelRatio || 1.0,
    },
  };
};
